import { useState } from 'react';
import {
  Box,
  Typography,
  Tabs,
  Tab
} from '@mui/material';
import InternalReportsConfiguration from './InternalReportsConfiguration';
import DataUploaderComponent from './DataUpload/DataUploaderComponent';

function DataConfiguration() {
    const [selectedTab, setSelectedTab] = useState(0);
    const handleTabChange = (_, newIndex) => setSelectedTab(newIndex);
    
    return (
        <Box sx={{ p: 3, minHeight: '100vh', background: '#FFFFFF' }}>
            <Typography variant="h4" gutterBottom sx={{ fontWeight: 600, mb: 3, color: 'text.primary',letterSpacing: '0.5px', }}>
                Data Configuration
            </Typography>

            <Tabs value={selectedTab} onChange={handleTabChange} sx={{ mb: 3 }}>
                <Tab label="Activity"/>
                <Tab label="Ex Fac"/>
            </Tabs>

            {selectedTab === 0 && (
                <DataUploaderComponent title="Activity" fileType="activity_data" />
            )}

            {selectedTab === 1 && (
                <InternalReportsConfiguration />
            )}
        </Box>
    );
}

export default DataConfiguration;
